import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { ButtonMain, Cards, Input, Selects, SliderMUI, TextArea } from "../../components";
import AddFile from "../../Tools/AddFile";
import { useContextHook } from "../../Context/ContextOPen";
import { useListPage } from "../../Context/listSignUp";
import { content } from "../../Context/translate";
import { checkToken, useFETCH, usePOST } from "../../Tools/APIs";
import { Col, Row } from "../../Tools/Grid-system";
import Loading from "../../Tools/Loading";

const UpdateProfile = ({ onProfileUpdate }) => {
  const { data, isLoading: isLoadingData } = useFETCH(checkToken && "v1/profile", "profile_refresh");
  const dataOld = data?.data?.data;
  const gender = dataOld?.gender === "FEMALE";
  
  const { setMessagesSuccess } = useContextHook();
  const { updateProfile } = useListPage();

  const {
    handleSubmit, setFormData, formData, loading, handleChangeInput,
    handleChangeSelect, viewImages, setViewImages, setImages, images,
    counter, setCounter, handleChangeArrayImages
  } = usePOST({});

  const [userImages, setUserImages] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    if (dataOld) {
      setUserImages(dataOld.images || []);
      setFormData({
        _method: "PUT",
        name: dataOld.secret_data?.name || "",
        username: dataOld.login_details?.username || "",
        email: dataOld.login_details?.email || "",
        phone_number: dataOld.secret_data?.phone_number || "",
        height: dataOld.my_specifications?.height || 160,
        age: dataOld.social_status?.age || 25,
        children: dataOld.social_status?.children !== null ? dataOld.social_status?.children : 0,
        weight: dataOld.my_specifications?.weight || 60,
        nationality_id: dataOld.nationality_residence?.nationality?.id || null,
        country_id: dataOld.nationality_residence?.country?.id || null,
        city_id: dataOld.nationality_residence?.city?.id || null,
        marriage_status_id: dataOld.social_status?.marriage_status?.id || null,
        hijab_status_id: dataOld.religious_commitment?.hijab_status?.id || null,
        beard_status_id: dataOld.religious_commitment?.beard_status?.id || null,
        prayer_status_id: dataOld.religious_commitment?.prayer_status?.id || null,
        employment_status_id: dataOld.study_work?.employment_status?.id || null,
        job_id: dataOld.study_work?.job?.id || null,
        social_status_id: dataOld.social_status?.social_status?.id || null,
        smoking_status_id: dataOld.religious_commitment?.smoking_status?.id || null,
        religiosity_status_id: dataOld.religious_commitment?.religiosity_status?.id || null,
        skin_color_id: dataOld.my_specifications?.skin_color?.id || null,
        health_status_id: dataOld.study_work?.health_status?.id || null,
        educational_level_id: dataOld.study_work?.educational_level?.id || null,
        monthly_income_range_id: dataOld.study_work?.monthly_income_range?.id || null,
        physique_status_id: dataOld.my_specifications?.physique_status?.id || null,
        financial_status_id: dataOld.study_work?.financial_status?.id || null,
        own_props: dataOld.own_props || "",
        future_wife_props: dataOld.future_wife_props || "",
        instagram: dataOld.instagram || "",
        facebook: dataOld.facebook || "",
        twitter: dataOld.twitter || "",
        tiktok: dataOld.tiktok || "",
      });
    }
  }, [dataOld, setFormData]);

  const handleSubmitMain = (e) => {
    e.preventDefault();
    if (isSubmitting) return;

    setIsSubmitting(true);
    toast.loading(content.loading, { id: "loading-update" });

    handleSubmit("v1/profile/update?_method=PUT", false, null, true, formData)
      .then((response) => {
        const updatedUser = response.data;
        if (updatedUser && updatedUser.images) {
          setUserImages(updatedUser.images);
        }
        
        setImages({});
        setViewImages([]);
        setCounter(0);

        toast.dismiss("loading-update");
        toast.success(content.ProfileUpdatedSuccessfully);
        
        if (onProfileUpdate) {
            onProfileUpdate(); 
        }
      })
      .catch(() => {
        toast.dismiss("loading-update");
      })
      .finally(() => {
        setIsSubmitting(false);
      });
  };

  if (isLoadingData && !dataOld) {
    return <Loading />;
  }
  
  return (
    <Col md={11} className="mx-auto">
      <Cards className="border-2 bg-white border-Secondary rounded-2xl p-6 md:p-10 mx-auto">
        {loading && <Loading />}
        <form onSubmit={handleSubmitMain}>
          <Row className="items-start">
            <h2 className="text-2xl font-bold text-Main mb-6 w-full">{content.BasicInformation}</h2>
            <Col md={6} lg={6}>
              <Input text={content.Username} name="username" value={formData?.username || ''} onChange={handleChangeInput} title={content.Username} />
            </Col>
            <Col md={6} lg={6}>
              <Input text={content.Email} title={content.Email} name="email" value={formData?.email || ''} onChange={handleChangeInput} />
            </Col>
            <Col md={6} lg={6}>
              <Input text={content.FullName} name="name" value={formData?.name || ''} onChange={handleChangeInput} title={content.FullName} />
            </Col>
            <Col md={6}>
              <Input text={content.PhoneNumber} name="phone_number" type="number" value={formData?.phone_number || ''} onChange={handleChangeInput} title={content.PhoneNumber} />
            </Col>
            
            <Col md={12}><hr className="my-6" /></Col>
            <h2 className="text-2xl font-bold text-Main mb-6 w-full">{content.PersonalDetails}</h2>

            <Col md={6}>
                <SliderMUI className="text-Secondary text-lg font-semibold" title={content.Age} unit={content.years} max={70} min={18} value={formData?.age} onChange={handleChangeInput} name="age" />
            </Col>
            <Col md={6}>
                <SliderMUI className="text-Secondary text-lg font-semibold" title={content.Height} unit={content.cm} max={220} min={100} value={formData?.height} onChange={handleChangeInput} name="height" />
            </Col>
            <Col md={6}>
                <SliderMUI className="text-Secondary text-lg font-semibold" title={content.Weight} unit={content.kg} max={200} min={30} value={formData?.weight} onChange={handleChangeInput} name="weight" />
            </Col>
            <Col md={6}>
                <SliderMUI className="text-Secondary text-lg font-semibold" title={content.Children} unit="" max={12} min={0} value={formData?.children} onChange={handleChangeInput} name="children" />
            </Col>

            {updateProfile?.map((e, index) => {
              if (!e.name) return null;
              if (["age", "weight", "height", "children"].includes(e.name)) return null; 
              if (e.name === "hijab_status_id" && !gender) return null;
              if (e.name === "beard_status_id" && gender) return null;
              
              return (
                  <Col md={6} key={index}>
                    <Selects
                      name={e.name}
                      text={e.title}
                      value={formData?.[e.name]}
                      onChange={handleChangeSelect}
                      options={e.options}
                    />
                  </Col>
              );
            })}

            <Col md={12}><hr className="my-6" /></Col>
            <h2 className="text-2xl font-bold text-Main mb-6 w-full">{content.SocialMediaLinks}</h2>
             <Col md={6} lg={6}>
              <Input text={content.instagram} title="Instagram URL" name="instagram" type={"url"} value={formData?.instagram || ''} onChange={handleChangeInput} />
            </Col>
            <Col md={6} lg={6}>
              <Input text={content.facebook} title="Facebook URL" name="facebook" type={"url"} value={formData?.facebook || ''} onChange={handleChangeInput} />
            </Col>
            <Col md={6} lg={6}>
              <Input text={content.twitter} title="Twitter URL" name="twitter" type={"url"} value={formData?.twitter || ''} onChange={handleChangeInput} />
            </Col>
            <Col md={6} lg={6}>
              <Input text={content.tiktok} title="Tiktok URL" name="tiktok" type={"url"} value={formData?.tiktok || ''} onChange={handleChangeInput} />
            </Col>

            <Col md={12}><hr className="my-6" /></Col>
            <h2 className="text-2xl font-bold text-Main mb-6 w-full">{content.AboutMe}</h2>
            <Col md={12}>
              <TextArea text={content.MySpecifications} name="own_props" value={formData?.own_props || ''} onChange={handleChangeInput} />
            </Col>
            <Col md={12}>
              <TextArea text={content.MyPartnerSpecifications} name="future_wife_props" value={formData?.future_wife_props || ''} onChange={handleChangeInput} />
            </Col>

            <Col md={12}><hr className="my-6" /></Col>
            <h2 className="text-2xl font-bold text-Main mb-6 w-full">{content.ProfilePhotos}</h2>
            <Col md={12}>
                <AddFile type="IMAGES" setFormData={setFormData} formData={formData} name="images" title={content.imageOptional} newImages={viewImages} setImagesToSend={setImages} setViewImages={setViewImages} images={userImages} setUserImages={setUserImages} onChange={handleChangeArrayImages} counter={counter} setCounter={setCounter} imagesToSend={images} />
            </Col>

            <Col md={12} className="!mt-8 flex justify-end">
              <ButtonMain
                onClick={handleSubmitMain}
                className="w-auto px-10"
                title={content.Save}
              />
            </Col>
          </Row>
        </form>
      </Cards>
    </Col>
  );
};

export default UpdateProfile;